import React, { useEffect } from "react";

import { useState } from "react";

import { Alert, AlertTitle } from "@material-ui/lab";
import { Button, Snackbar } from "@material-ui/core";
import moment from "moment";
import { sto } from "./Context/InshData";
import { uri } from "./help/Api";
import emailjs from '@emailjs/browser';
import axios from "axios";
import { getLS } from "./utils/useLS";
import { useTranslation } from "react-i18next";

export function isExpired2(startDate) {
  const dateStart = (moment(startDate).format("YYYY-MM-DD"));

  console.log("bbbb days total is", startDate);
  if (startDate == null)
    return false;
  let sdate = moment(new Date());
  const daysTotal = sdate.diff(dateStart, 'days');
  console.log("the days total is", daysTotal);

  return daysTotal >= 365;
}
export function isExpired(startDate, endDate) {
  // const dateStart = (moment(startDate).format("YYYY-MM-DD"));
  // if (endDate == null) {
  //   if (startDate == null)
  //     return true;
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateStart, 'days');
  //   return daysTotal >= 345;
  // } else {
  //   const dateEnd = (moment(endDate).format("YYYY-MM-DD"));
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateEnd, 'days');
  //   return daysTotal < 30;
  // }
  if (startDate == null)
    return true;
  let sdate = moment(new Date());
  const daysTotal = sdate.diff(startDate, 'days');
  return daysTotal >= 335;

}


export function daysExpireds(startDate) {


  if (startDate == null)
    return 10;
  let sdate = moment(new Date());
  const daysTotal = sdate.diff(startDate, 'days');
  let dayReaims = parseInt(365 - daysTotal);
  return dayReaims;

  // if (!startDate) return 30;
  // const dateStart = (moment(startDate).format("YYYY-MM-DD"));
  // const sttdate=new Date(dateStart);

  // const oneYear=new Date(dateStart);
  // oneYear.setFullYear( oneYear.getFullYear()+1);

  // const today=new Date().format("YYYY-MM-DD");

  // const difftime=oneYear-today;

  // const diffdays=Math.ceil(difftime/(1000*60*60*24));

  // return diffdays;


}
function SubScriptionEndingAlert(props) {
  const { startDate, endDate } = props;
  const { t } = useTranslation(["forms"]);
  const [showAlert, setShowAlert] = useState(true);
  const [, setSending] = useState(true);

  const dateStart = (moment(startDate).format("YYYY-MM-DD"));
  useEffect(() => {
    console.log("the ", dateStart);
  });


  const sendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    const infoCon = getLS("infoConn", {});

    const templateParams = {
      to_name: "Orax Company",
      from_name: sto?.found,
      message: `The client has number ${infoCon?.changip}required Renew his subscription. his api is ${uri}`,
    }
    console.log("the sto data is", sto)
    emailjs.send(
      "service_i41dmcc",
      "template_hh092kl",
      templateParams,
      "GroRBwoPYrc1vr7JJ"
    ).then((response) => { console.log("the response is", response) }, (err) => { console.log("the error is", err); });


    // send message to whatsapp 
    const whatsFormData = {
      appkey: "42b3c4c8-9319-4b5f-b3ba-7ae69daa8554xr",
      deviceid: "42b3c4c8-9319-4b5f-b3ba-7ae69daa8554xr",
      authkey: "xrlEwtowWRKMHcQDQBBf509STVg1HDCnGrdDzEuEikqmPm41yt",
      to: "+966578754639",
      // to:"+966552661598",
      message: `Hi, oraxsoft \nThe client ${sto?.found} with phone number\n ${infoCon?.changip} need Renew his subscription.\n\n his api is ${uri}`
    }

    await axios.post("https://sender.oraxsoft.net/api/create/message", FormData)
      .then(res => console.log("response is1", res))
      .catch(req => console.log("whats app failed sending1", req));

    const mosaFD = { ...whatsFormData, to: "+966578754639" }
    await axios.post("https://sender.oraxsoft.net/api/create/message", mosaFD)
      .then(res => console.log("response is 2", res))
      .catch(req => console.log("whats app failed sending2", req));

    setSending(false);
    setShowAlert(false);
  }

  if (isExpired(startDate, endDate)) {
    // if(daysExpireds(startDate)<=30)
    const remainingDays = daysExpireds(startDate);

    return (
      <React.Fragment>
        <Snackbar open={showAlert} fullWidth autoHideDuration={60000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert fullWidth severity={"error"} style={{ whiteSpace: "pre-wrap" }}
            onClose={() => {
              setShowAlert(false);
              setTimeout(() => {
                setShowAlert(false);
              }, 900000);
            }}>
            {remainingDays > 0 ?
              (
                <>
                  <AlertTitle>

                    {t("dear-customer")}
                    {"\n"}
                    {t("subscription-ending-notice", { days: remainingDays })}
                         {"\n"}
                    {t("subscription-renewal-reminder")}

                  </AlertTitle>
                  {`${t("contact-with-us")}: +966578754639`}
                  {"\n"}
                  <Button onClick={sendEmail} variant="outlined" color="primary" size="small">
                    {t("request-renewal")}
                  </Button>
                </>
              ) :
              (
                <>
                  <AlertTitle>

                    {t("dear-customer")}
                    {"\n"}
                   {t("subscription-ended-notice")}
                   {"\n"}
                   {t("subscription-renewal-reminder")}


                  </AlertTitle>
                  {`${t("contact-with-us")}: +966578754639`}
                  {"\n"}
                  <Button onClick={sendEmail} variant="outlined" color="primary" size="small">
                    {t("request-renewal")}
                  </Button>
                </>
              )
            }


            {/* <AlertTitle>
              {"اشتراكك في خدمة اوراكس كلاود انتهى " + daysExpireds(startDate)}
            </AlertTitle>
            {" عزيزي المشترك "}
            {" اشتراكك في خدمة اوراكس كلاود انتهى "}
            {moment(dateStart).add(1, 'years').format('YYYY-MM-DD')}
            {" للاستمرار في الاستفادى من خدمات اوراكس كلاود يرجى تجديد اشتراكك "}
            {"  contact with us:   " + "+966578754639"}
            {"\n"}
            <Button onClick={sendEmail} variant="outlined" color="primary" size="small">
              طلب التجديد
            </Button> */}
          </Alert>
        </Snackbar>
      </React.Fragment>
    );
  }

  return <></>
}

export default SubScriptionEndingAlert;
